import { Link } from "react-router-dom";
import { ArrowRight, Calculator } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { TechnicalDisclaimer } from "../components/site/TechnicalDisclaimer";
import { CTASection } from "../components/site/CTASection";
import { PU_ARTICLES, PU_SECTIONS, CALCULATORS } from "../data/technical";

export default function PUCentre() {
  return (
    <div>
      <PageHero
        variant="dark"
        label="Polyurethane Knowledge Centre"
        title="Understanding Polyurethane"
        intro="Learn the fundamentals behind polyurethane formulation, raw-material selection, equivalent weights, NCO/OH balance and application development — the logic, not just the recipe."
        crumbs={[{ label: "Technical Hub", to: "/technical-hub" }, { label: "Polyurethane" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <div className="mb-12 grid gap-px border border-brand-line bg-brand-line sm:grid-cols-2 lg:grid-cols-4">
            {CALCULATORS.map((c) => (
              <Link key={c.slug} to={`/technical-hub/calculators/${c.slug}`} className="group bg-brand-ink p-6 text-white transition-colors hover:bg-brand-bluedark">
                <Calculator className="h-6 w-6 text-brand-red" strokeWidth={1.5} />
                <h3 className="mt-3 font-heading text-base font-bold leading-snug">{c.title}</h3>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-white/80">
                  Open <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </Link>
            ))}
          </div>

          {PU_SECTIONS.map((section) => {
            const items = PU_ARTICLES.filter((a) => a.section === section);
            if (!items.length) return null;
            return (
              <div key={section} className="mb-12">
                <SectionLabel>{section}</SectionLabel>
                <div className="grid gap-px border border-brand-line bg-brand-line md:grid-cols-2 lg:grid-cols-3">
                  {items.map((a) => (
                    <Link
                      key={a.slug}
                      to={`/technical-hub/polyurethane/${a.slug}`}
                      data-testid={`pu-article-${a.slug}`}
                      className="group flex flex-col bg-white p-6 transition-colors hover:bg-brand-blue/[0.03]"
                    >
                      <h3 className="font-heading text-base font-bold leading-snug text-brand-ink group-hover:text-brand-blue">
                        {a.title}
                      </h3>
                      <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-muted">{a.summary}</p>
                      <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-brand-blue">
                        Read <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}

          <TechnicalDisclaimer />
        </div>
      </section>

      <CTASection primary={{ to: "/technical-hub/calculators", label: "Open PU Calculators" }} secondary={{ to: "/advisory/industrial-advisory", label: "Industrial Advisory" }} />
    </div>
  );
}
